import axios from 'axios';

const api = axios.create({ baseURL: '/api', timeout: 10000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.put('/auth/change-password', data),
};

export const employeeAPI = {
  getMyProfile: () => api.get('/employees/me'),
  updateMyProfile: (data) => api.put('/employees/me', data),
  getMyHistory: () => api.get('/employees/me/history'),
  getMyAccruals: () => api.get('/employees/me/accruals'),
  getAll: () => api.get('/employees'),
  getById: (id) => api.get(`/employees/${id}`),
  create: (data) => api.post('/employees', data),
  update: (id, data) => api.put(`/employees/${id}`, data),
  updateVacationDays: (id, data) => api.put(`/employees/${id}/vacation-days`, data),
  toggleActive:  (id, data) => api.put(`/employees/${id}/toggle-active`, data),
  resetPassword: (id)       => api.put(`/employees/${id}/reset-password`),
};

export const supervisorAPI = {
  getById: (id) => api.get(`/employees/supervisors/${id}`),
  getEmployeeProfile: (id) => api.get(`/employees/supervisors/${id}/employee`),
  update: (id, data) => api.put(`/employees/supervisors/${id}`, data),
};

export const vacationAPI = {
  create: (data) => api.post('/vacations', data),
  getMine: () => api.get('/vacations/mine'),
  cancel: (id) => api.put(`/vacations/${id}/cancel`),
  getPending: () => api.get('/vacations/pending'),
  process: (id, data) => api.put(`/vacations/${id}/process`, data),
  getAll: (params) => api.get('/vacations', { params }),
};

export const leaveAPI = {
  create: (data) => api.post('/leaves', data),
  getMine: () => api.get('/leaves/mine'),
  getSummary: () => api.get('/leaves/summary'),
  cancel: (id) => api.put(`/leaves/${id}/cancel`),
  getPending: () => api.get('/leaves/pending'),
  process: (id, data) => api.put(`/leaves/${id}/process`, data),
};

export const notificationAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
};

export const adminAPI = {
  promoteToSupervisor: (employeeId) => api.post(`/admin/employees/${employeeId}/promote`),
  getEmployeesForFilter: () => api.get('/admin/informe/empleados'),
  getVacationReport2: (params) => api.get('/admin/informe/vacaciones', { params }),
  getLeaveReport: (params) => api.get('/admin/informe/permisos', { params }),
  getSupervisorVacationReport: (params) => api.get('/admin/informe/supervisor/vacaciones', { params }),
  getSupervisorLeaveReport: (params) => api.get('/admin/informe/supervisor/permisos', { params }),
  getStats: () => api.get('/admin/stats'),
  getVacationReport: (params) => api.get('/admin/reports/vacations', { params }),
  getBirthdays: (params) => api.get('/admin/reports/birthdays', { params }),
  getAnniversaries: (params) => api.get('/admin/reports/anniversaries', { params }),
  getTodayAbsences: (params) => api.get('/admin/today-absences', { params }),
  getSupervisors: () => api.get('/admin/supervisors'),
  createSupervisor: (data) => api.post('/admin/supervisors', data),
  getAllAccruals: () => api.get('/admin/accruals'),
  getAccrualHistory: (employeeId) => api.get(`/admin/accruals/${employeeId}`),
  triggerAnniversaries: () => api.post('/admin/trigger-anniversaries'),
};

export const departmentAPI = {
  getAll: () => api.get('/departments'),
  create: (data) => api.post('/departments', data),
  update: (id, data) => api.put(`/departments/${id}`, data),
  remove: (id) => api.delete(`/departments/${id}`),
};

export const reportAPI = {
  getEmployees:  () => api.get('/reports/employees'),
  getVacations:  (params) => api.get('/reports/vacations', { params }),
  getLeaves:     (params) => api.get('/reports/leaves', { params }),
};

export const auditAPI = {
  getLogs:  (params) => api.get('/audit',       { params }),
  getUsers: ()       => api.get('/audit/users'),
};

export const holidayAPI = {
  getAll:        (params) => api.get('/holidays', { params }),
  checkRange:    (params) => api.get('/holidays/check-range', { params }),
  create:        (data)   => api.post('/holidays', data),
  update:        (id, data) => api.put(`/holidays/${id}`, data),
  remove:        (id)     => api.delete(`/holidays/${id}`),
  recalculate:   ()       => api.post('/holidays/recalculate'),
};

export default api;
